export enum LinkTypeEnum {
  NO_URL = 0,
  URL = 1,
  ROUTER_LINK = 2,
  URL_NEW_TAB = 3,
}
